import React from "react";
import { Menu, Image, Icon } from "semantic-ui-react";

import logo from "../logo.png";
import bernardB from "../bernard_B.svg";
import { apiTypes, formatApiTypes } from "../App";

export interface HDHeaderProps {
    activeApi: apiTypes;
    toggleSidebar: any;
    changeActiveApi: any;
}

const HDHeader = ({ activeApi, toggleSidebar, changeActiveApi }: HDHeaderProps) => {
    const header = (apiType: apiTypes) => {
        if (apiType === "overview") return "Overview";
        if (apiType === "attribution") return "Data Attributions";
        return `${formatApiTypes(apiType)} API`;
    };

    return (
        <Menu fixed="top" fluid style={{ zIndex: 1000, opacity: ".95", height: "60px" }} borderless>
            <Menu.Item
                header
                style={{ borderRight: "1px solid #e1e1e1" }}
                onClick={() => changeActiveApi("overview")}>
                <Image size="small" src={logo} />
            </Menu.Item>
            <Menu.Item onClick={toggleSidebar}>
                <Icon name="sidebar" />
            </Menu.Item>
            <Menu.Item>
                <h3 style={{ color: "#666666" }}>
                    Developer Resources:{" "}
                    <span style={{ marginLeft: "0.5em", color: "#FF0000" }}>
                        {header(activeApi)}
                    </span>
                </h3>
            </Menu.Item>
            <Menu.Item position="right" as="a" href="https://www.bernard-gruppe.com/de/unternehmen/bernard-technologies-gmbh">
                <Image src={bernardB} style={{ height: "30px", marginRight: "10px" }} />
+                <h3 style={{ color: "#FF0000", marginBlock: 0 }}>bernard-gruppe.com</h3>
            </Menu.Item>
        </Menu>
    );
};
export default HDHeader;
